import { render, staticRenderFns } from "./ListePatient.vue?vue&type=template&id=15906af9"
import script from "./ListePatient.vue?vue&type=script&lang=js"
export * from "./ListePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports